import { getBaseUrl } from "app/tools/repository"
import { UiConfigAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { IUIConfiguration, IUIConfigurationRepository } from "./model"

export const uiConfigurationRPO: IUIConfigurationRepository = {
  getConfiguration(): Promise<IUIConfiguration> {
    return new Promise<IUIConfiguration>((resolve, reject) => {
      try {
        UiConfigAPI.getApiUiConfig()
          .then((response: any) => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting ui config", error)
            reject("ui-config.get.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting ui config", ex)
        reject("ui-config.get.error.unexpected")
      }
    })
  },
  getDefaultConfiguration(): Promise<IUIConfiguration> {
    return new Promise<IUIConfiguration>((resolve, reject) => {
      try {
        UiConfigAPI.getApiAdminUiConfigDefault()
          .then((response: any) => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting default ui config", error)
            reject("ui-config.get.default.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting ui config", ex)
        reject("ui-config.get.error.unexpected")
      }
    })
  },
  saveConfiguration(uiConfig: IUIConfiguration): Promise<IUIConfiguration> {
    return new Promise<IUIConfiguration>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        UiConfigAPI.putApiAdminUiConfig(uiConfig)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while deleting media", error)
            reject("media.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting media", ex)
        reject("media.delete.error.unexpected")
      }
    })
  },
  getUploadUrl(): string {
    return `${getBaseUrl()}/api/admin/ui-config/upload-image`
  }
}
